import { memo } from 'react';
import Col from 'react-bootstrap/Col';
import Form from 'react-bootstrap/Form';

function AggregatorHubSpotRecordIdForm({ aggregatorHubspotCompanyRecordId, changeValue }) {
  return (
    <>
      <Col md={2} className="bo-same-line">
        <Form.Label>HubSpot company record ID:</Form.Label>
      </Col>
      <Col md={4} className="bo-same-line">
        <Form.Control
          className="bo-input"
          type="text"
          name="hubspotCompanyRecordId"
          id="hubspotCompanyRecordId"
          placeholder="Record ID"
          value={aggregatorHubspotCompanyRecordId || ''}
          onChange={changeValue}
        />
      </Col>
    </>
  );
}

export default memo(AggregatorHubSpotRecordIdForm);
